//css-------------------
import "@/css/home/search.scss";



//components js-------------------
import(/* webpackPrefetch: true */ "@/js/share/components/_common_lazy");
import(/* webpackPrefetch: true */ "@/js/share/components/_font_family");
import { init_imageloaded } from "@/js/share/components/_imageloader.js";
import { sponsor_swiper } from "@/js/share/components/_sponsor_swiper.js";
import { sidenav_toggle } from "@/js/share/components/_sidenav.js";
import { getUrlParameter } from "@/js/share/components/_globeVar.js";


//npm lib  
import $ from "jquery";
import { createApp, baseData, baseWatch, baseMethods } from "@/js/share/_home_app";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";

const app = createApp({
    data() {
        return {
            ...baseData(),
            form_show: true,
        };
    },
    watch: {
        ...baseWatch(this),
    },
    mounted() {
        const _this = this;
        this.fastlink_toggle();
        init_imageloaded(function () {
            sponsor_swiper();
            //
        });
    },
    methods: {
        ...baseMethods,
        sidenav_toggle,
        form_submit() {
            location.href = '?title=' + $('input[name=title]').val() + '&select=' + $('select[name=select]').val();
        },
    },
}).mount("#app");


// $(function() {

//     let _href;
//     $('#form').submit(function(e) {
//         e.preventDefault();
//         location.href = '?select=' + $('select[name=select]').val() + '&title=' + $('input[name=title]').val();
//     });

//     $('.result_count').click(function() {
//         _href = $(this).attr('href');
//         TweenMax.to('html, body', 1, { scrollTop: $(_href).offset().top, ease: Quart.easeOut });
//     });

// });
